"use client";

import { motion } from "framer-motion";
import { useRef, useEffect } from "react";

const WhyChooseUsSection = () => {
  const whyChooseUs = [
    {
      number: "01",
      title: "Healthcare Handling Knowledge",
      description:
        "We have more than 15 years of experienced staff in handling pharmaceutical, medicine, and all types of healthcare products.",
      bgColor: "#922D27B8",
    },
    {
      number: "02",
      title: "Global Coverage, Indian Standards",
      description:
        "Our headquarters is located in Mumbai, serving from 32+ locations in India + all locations worldwide.",
      bgColor: "#285784B3",
    },
    {
      number: "03",
      title: "Stringent Adherence to Healthcare Policies",
      description:
        "Our ISO 9001:2015 certified logistics applies international healthcare standards and safety measures to ensure safe delivery.",
      bgColor: "#922D27B8",
    },
    {
      number: "04",
      title: "Industry Expertise",
      description:
        "Currently serving 95% pharmaceutical companies, Quick India Logistics has expanded its services to auto parts and electronics for safe and timely deliveries.",
      bgColor: "#285784B3",
    },
  ];

  return (
    <motion.section
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="relative py-20 overflow-hidden"
    >
      {/* Background Video */}
      <div className="absolute inset-0 z-0">
        <video
          // ref={videoRef}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          className="w-full h-full object-cover"
          poster="/assets/photos/why-choose-us/background.jpg" // Fallback image
        >
          <source src="/assets/videos/home/ne-3.mp4" type="video/mp4" />
          {/* Fallback to background image if video doesn't load */}
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage:
                "url('/assets/photos/why-choose-us/background.jpg')",
            }}
          />
        </video>
        <div className="absolute inset-0 bg-black opacity-50"></div>{" "}
        {/* Increased opacity for better contrast */}
      </div>

      <div className="max-w-7xl mx-auto px-4 relative z-10">
        {/* Header Section - Centered */}
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-center mb-12"
        >
          {/* Main Heading */}
          <motion.h2
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="text-xl md:text-2xl font-bold text-white mb-2"
          >
            Why Choose Us
          </motion.h2>

          {/* Subheading */}
          <motion.h3
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="text-lg md:text-lg text-white font-light max-w-4xl mx-auto"
          >
            What Makes Quick India Logistics Different? A Reliable Name in
            Healthcare Distribution
          </motion.h3>
        </motion.div>

        <motion.div
          initial={{ x: -50, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3"
        >
          {whyChooseUs.map((item, index) => (
            <motion.div
              key={index}
              initial={{ y: 20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              whileHover={{ y: -5, scale: 1.02 }}
              transition={{ duration: 0.4, delay: 0.6 + index * 0.1 }}
              className="p-6 rounded-sm shadow-lg backdrop-blur-sm transition-all duration-300"
              style={{ backgroundColor: item.bgColor }}
            >
              <div className="flex flex-col h-full justify-between">
                <div className="flex-shrink-0 w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center mb-4">
                  <span className="text-black font-bold text-lg">
                    {item.number}
                  </span>
                </div>
                <div className="flex-grow">
                  <h3 className="text-lg font-bold text-white mb-3 leading-tight">
                    {item.title}
                  </h3>
                  <p className=" text-white text-opacity-90 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </motion.section>
  );
};

export default WhyChooseUsSection;
